import { useRef, useState, useCallback } from "react";

/**
 * Lightweight spam protection shared by every lead form.
 *
 * - A honeypot input that is hidden from humans and assistive tech but that
 *   naive bots fill in anyway.
 * - How long the visitor spent on the form, so instant submissions can be
 *   dropped server-side.
 *
 * Both values are sent with the payload; the server decides what to do.
 */
export function useLeadGuard() {
  const [hp, setHp] = useState("");
  const mounted = useRef(Date.now());

  const guardFields = useCallback(() => ({ hp, elapsedMs: Date.now() - mounted.current }), [hp]);

  const honeypot = (
    <div aria-hidden className="absolute left-[-9999px] top-0 h-0 w-0 overflow-hidden" data-lpignore="true">
      <label>
        Company website (leave blank)
        <input
          type="text"
          tabIndex={-1}
          autoComplete="off"
          value={hp}
          onChange={(e) => setHp(e.target.value)}
        />
      </label>
    </div>
  );

  return { guardFields, honeypot };
}
